import type { TranslationKeys } from '../types';

export const enUS: TranslationKeys = {
  // Home page
  'home.title': 'AI-Powered Meeting Platform',
  'home.createMeeting': 'Create New Meeting',
  'home.creating': 'Creating...',
  'home.or': 'or',
  'home.joinPlaceholder': 'Enter code or link',
  'home.join': 'Join',
  'home.errorDefault': 'An error occurred',
  'home.meetingCreateFailed': 'Failed to create meeting',
  'home.poweredBy': 'Powered by',

  // Join page
  'join.unableToJoin': 'Unable to Join Meeting',
  'join.tryAgain': 'Try Again',
  'join.creatingSession': 'Creating new session...',
  'join.joiningMeeting': 'Joining meeting...',
  'join.loadingInfo': 'Loading meeting info...',
  'join.failedToJoin': 'Failed to join meeting',
  'join.unexpectedError': 'An unexpected error occurred',
  'join.encounteredError': 'Encountered an unexpected error: {message}',
  'join.meetingDetails': 'Meeting Details',
  'join.ok': 'OK',
  'join.cameraUnavailable': 'Camera is unavailable, it may be used by another application.',
  'join.micUnavailable': 'Microphone is unavailable, it may be used by another application.',
  'join.mediaDeviceError': 'Media device error: {message}',

  // PreJoin
  'prejoin.joinLabel': 'Join Room',
  'prejoin.userLabel': 'Username',
  'prejoin.micLabel': 'Microphone',
  'prejoin.camLabel': 'Camera',

  // Settings menu
  'settings.mediaDevices': 'Media Devices',
  'settings.recording': 'Recording',
  'settings.camera': 'Camera',
  'settings.microphone': 'Microphone',
  'settings.speakerHeadphones': 'Speaker & Headphones',
  'settings.audioOutput': 'Audio Output',
  'settings.recordMeeting': 'Record Meeting',
  'settings.meetingRecording': 'Meeting is currently being recorded',
  'settings.noActiveRecordings': 'No active recordings for this meeting',
  'settings.startRecording': 'Start Recording',
  'settings.stopRecording': 'Stop Recording',
  'settings.close': 'Close',

  // Control bar
  'controls.microphone': 'Microphone',
  'controls.camera': 'Camera',
  'controls.leave': 'Leave',
  'controls.chat': 'Chat',
  'controls.shareScreen': 'Share screen',
  'controls.stopScreenShare': 'Stop screen share',
  'controls.settings': 'Settings',
  'controls.pause': 'Pause meeting',
  'controls.allowAudio': 'Allow Audio',

  // Chat panel
  'chat.title': 'Messages',
  'chat.placeholder': 'Enter a message...',
  'chat.send': 'Send',
  'chat.close': 'Close chat',

  // Connection state toast
  'connection.connecting': 'Connecting',
  'connection.reconnecting': 'Reconnecting',
  'connection.disconnected': 'Disconnected',

  // Participant tile
  'participant.screenShareSuffix': "'s screen",

  // Question panel
  'question.speakAnswer': 'Please answer out loud',

  // Pause overlay
  'pause.title': 'Meeting paused',
  'pause.description': 'You can resume from where you left off when ready.',
  'pause.resume': 'Resume meeting',
  'pause.failed': 'Could not pause meeting. Please try again.',
  'pause.resumeFailed': 'Could not resume meeting. Please try again.',
  'pause.pausing': 'Pausing meeting...',
  'pause.resuming': 'Resuming meeting...',
  'pause.waitingAgent': 'Waiting for {name}...',
  'pause.agentFallback': 'the assistant',

  // Common
  'common.processing': 'Processing...',
  'common.close': 'Close',
  'common.download': 'Download',
  'common.image': 'Image',
  'common.previousTab': 'Previous tab',
  'common.nextTab': 'Next tab',

  // Content panel
  'content.openPdf': 'Open PDF',
  'content.pdfHint': 'PDF will open in a new tab',
  'content.loadingPdf': 'Loading PDF...',
  'content.loadingImage': 'Loading image...',
  'content.imageLoadFailed': 'Image failed to load. Use download button.',
  'content.clickDownload': 'Click download button to open',
  'content.document': 'Document',
  'content.text': 'Text',
  'content.tabQuestion': 'QUESTION',
  'content.tabText': 'TEXT',
  'content.tabFile': 'FILE',
  'content.badgeImage': 'IMAGE',
  'content.badgeFile': 'FILE',

  // Presentation panel
  'presentation.loading': 'Loading presentation…',
  'presentation.loadingDetail': 'markdown: {count} characters',
  'presentation.initFailed': 'Presentation could not be initialised',

  // Mermaid diagram
  'diagram.loading': 'Loading diagram...',
  'diagram.syntaxError': 'Diagram syntax error',
  'diagram.renderFailed': 'Failed to render diagram',

  // Public slide preview page
  'preview.apiUrlMissing': 'API URL is not configured',
  'preview.loadFailed': 'Presentation could not be loaded',
  'preview.loading': 'Loading…',

  // Settings menu
  'settings.backgroundEffects': 'Background Effects',
  'settings.backgroundNone': 'None',
  'settings.backgroundBlur': 'Blur',
  'settings.backgroundDesk': 'Desk',
  'settings.backgroundNature': 'Nature',
  'settings.enableNoiseCancellation': 'Enable Enhanced Noise Cancellation',
  'settings.disableNoiseCancellation': 'Disable Enhanced Noise Cancellation',
  'settings.recordingNoEndpoint': 'No recording endpoint specified',
  'settings.recordingEncryptedUnsupported':
    'Recording of encrypted meetings is currently not supported',
  'settings.recordingInProgress': 'This meeting is being recorded',

  // Sent to the AI agent
  'agent.questionDismissed':
    '[The user closed the question panel without answering, continue naturally]',
};
